import PropTypes from 'prop-types'
import styled from 'styled-components'

import Button from '../Button'
import Container from '../Container'
import Display from '../Display'
import Headline from '../Headline'
import Text from '../Text'

const Hero = (props) => {
  const {
    data: {
      hero_eyebrow: eyebrow,
      hero_headline: headline,
      hero_subtext: subtext,
      hero_button_text: buttonText,
      hero_button_href: buttonHref,
    },
  } = props

  const splitHeadline = headline.match(/\b[\w']+(?:[^\w\n]+[\w']+){0,1}\b/g)

  return (
    <Wrapper center>
      <Eybrow size="eyebrow">{eyebrow}</Eybrow>
      <HeadingWrapper>
        {splitHeadline.map((words, index) => (
          <StyledDisplay element={index === 0 ? 'h1' : 'h2'} key={words}>{words}</StyledDisplay>
        ))}
      </HeadingWrapper>
      <Subtext>{subtext}</Subtext>
      <StyledButton buttonContent={buttonText} buttonHref={buttonHref} />
    </Wrapper>
  )
}

const Wrapper = styled(Container)`
  text-align: center;
  background-color: ${ ({ theme }) => theme.colors.cream };

  > div {
    padding-top: 100px;
  }
`

const Eybrow = styled(Text)`
  margin: 0 0 32px;
  text-transform: uppercase;
`

const StyledDisplay = styled(Display)`
  margin: 0;
`

const Subtext = styled(Headline)`
  margin: 32px 0 0;
`

const StyledButton = styled(Button)`
  height: fit-content;
  margin-top: 72px;
`

const HeadingWrapper = styled.div`
  flex-direction: column;
  display: flex;

  @media screen and (max-width: ${ ({ theme }) => theme.breakpoints.xs1 }) {
    display: inline;
    width: 80%;

    > span {
      display: inline;

      > span {
        display: inline;

        > * {
          display: inline;
          font-size: 60px;
        }
      }

      &:first-child {
        > span {
          > h1 {
            margin-right: 10px;
          }
        }
      }
    }
  }
`

Hero.propTypes = {
  data: PropTypes.objectOf(PropTypes.string).isRequired,
}

export default Hero
